<template>
  <b-table
    :loading="loading"
    :data="RelationData"
    :mobile-cards="false"
    narrowed
    bordered
    draggable
  >
    <b-table-column
      field="code"
      :label="$t('attributes.code')"
      centered
      v-slot="props"
    >
      {{
        props.row.product_code ? props.row.product_code : props.row.group_code
      }}
    </b-table-column>
    <b-table-column
      field="product_name"
      :label="$t('attributes.product_name')"
      centered
      v-slot="props"
    >
      <span v-html="props.row.product_name"></span>
    </b-table-column>
  </b-table>
</template>

<script>
import { ATTRIBUTES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'AttributesRelationList',
  props: {
    attribute: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      sending: false,

      RelationData: []
    }
  },
  mounted() {
    this.loadRelationData(this.attribute.id)
  },
  methods: {
    async loadRelationData(id) {
      try {
        this.loading = true
        const api = `${ATTRIBUTES_API}/${id}/relation`

        const res = await this.axios.get(api)
        this.RelationData = res.data.data
      } catch (e) {
        this.RelationData = []

        notifyService.fetch_error('header', e)
      } finally {
        this.loading = false
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
